import styled from 'styled-components';

import {
  companyColor, defaultColor, spacing,
} from 'styles/theme';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ dark }) => (dark ? companyColor('font') : defaultColor('backgroundLight'))};
`;

export const SummaryTail = styled.div`
  display: grid;
  grid-template-columns: minmax(280px, max-content);
  margin-left: auto;
  gap: ${spacing('medium')};
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${spacing('small')};
`;
